/** Production Worklist / Cycle ที่เปิดอยู่ / สถานะ Work Center (D-181) — อ่านอย่างเดียว ตามโรงงานที่ถือ */

import { useState } from 'react';

import { RecordPanel } from '../components/RecordPanel';

export interface ProductionWorklistScreenProps {
  readonly apiBaseUrl?: string;
  readonly fetchImpl?: typeof fetch;
}

const TABS = [
  {
    id: 'worklist',
    label: 'งานที่ต้องทำ (Worklist)',
    path: '/v1/production-worklist',
    columns: [
      { key: 'order_no', label: 'ใบสั่งผลิต' },
      { key: 'product_code', label: 'สินค้า' },
      { key: 'operation_seq', label: 'Op' },
      { key: 'work_center_code', label: 'Work Center' },
      { key: 'planned_quantity', label: 'แผน' },
      { key: 'qty_good_confirmed', label: 'ผลิตดีแล้ว' },
      { key: 'staged_quantity', label: 'จัดเตรียมแล้ว' },
      { key: 'predecessors_done', label: 'Op ก่อนหน้าเสร็จ' },
      { key: 'open_cycle', label: 'กำลังเดินเครื่อง' },
    ],
  },
  {
    id: 'status',
    label: 'สถานะ Work Center',
    path: '/v1/work-center-status',
    columns: [
      { key: 'work_center_code', label: 'Work Center' },
      { key: 'name', label: 'ชื่อ' },
      { key: 'open_cycles', label: 'Cycle ที่เปิด' },
      { key: 'ready_operations', label: 'พร้อมเริ่ม' },
      { key: 'waiting_operations', label: 'รอ Op ก่อนหน้า' },
      { key: 'oldest_open_start', label: 'เปิดเก่าสุด' },
    ],
  },
  {
    id: 'cycles',
    label: 'Cycle ที่เปิดค้าง',
    path: '/v1/open-cycles',
    columns: [
      { key: 'order_no', label: 'ใบสั่งผลิต' },
      { key: 'product_code', label: 'สินค้า' },
      { key: 'operation_seq', label: 'Op' },
      { key: 'work_center_code', label: 'Work Center' },
      { key: 'started_by_employee_id', label: 'เริ่มโดย' },
      { key: 'start_time', label: 'เริ่มเมื่อ' },
      { key: 'open_minutes', label: 'เปิดมา (นาที)' },
    ],
  },
] as const;

export function ProductionWorklistScreen({ apiBaseUrl, fetchImpl }: ProductionWorklistScreenProps) {
  const [tabId, setTabId] = useState<(typeof TABS)[number]['id']>('worklist');
  const [plant, setPlant] = useState('');
  const tab = TABS.find((t) => t.id === tabId) ?? TABS[0];
  const io = {
    ...(apiBaseUrl === undefined ? {} : { apiBaseUrl }),
    ...(fetchImpl === undefined ? {} : { fetchImpl }),
  };

  return (
    <div className="cap-page" data-testid="production-worklist">
      <div className="cap-page__head">
        <h1 className="cap-page__title">งานผลิตหน้าเครื่อง (Worklist)</h1>
      </div>
      <div className="cap-filters" role="tablist">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={t.id === tabId}
            className={`cap-button ${t.id === tabId ? 'cap-button--primary' : 'cap-button--ghost'}`}
            onClick={() => setTabId(t.id)}
          >
            {t.label}
          </button>
        ))}
        <label className="cap-field">
          <span className="cap-field__label">รหัสโรงงาน (จำเป็น)</span>
          <input
            className="cap-input"
            aria-label="รหัสโรงงาน"
            value={plant}
            onChange={(e) => setPlant(e.target.value.toUpperCase())}
          />
        </label>
      </div>
      {plant.trim() === '' ? (
        <p className="cap-notice__text" data-testid="worklist-need-plant">
          เลือกรหัสโรงงานก่อน
        </p>
      ) : (
      <RecordPanel
        key={tab.id}
        path={tab.path}
        params={{ plant_code: plant }}
        columns={tab.columns}
        testId={`worklist-${tab.id}`}
        {...io}
      />
      )}
    </div>
  );
}
